import React from 'react';
import { View, ScrollView, TouchableOpacity, Platform, useWindowDimensions } from 'react-native';
import { Button, Text, TouchableRipple, TextInput } from 'react-native-paper';
import { Sort, ArrowRight2 } from 'iconsax-react-native';
import { useForm, Controller } from "react-hook-form";
import RBSheet from "react-native-raw-bottom-sheet";
import { MainContext } from '../../contexts/MainContext';
import Select from '../Select/Select';
import TwinNumberTextInput from '../TwinNumberTextInput/TwinNumberTextInput';
import Checkbox from '../CheckBox/CheckBox';

export default function Filters({filtersValue = {}, submitFilterData, sortData, sortValue, adsDetail, hideFilter = false, isMy = false, isCus = false}){
  const myContext = React.useContext(MainContext);
  const refRBSheet = React.useRef();
  const {height, width} = useWindowDimensions();
  const siteAddsTypes = myContext.addsTypes ? myContext.addsTypes : {transactions: []};
  const [filterCount, setFilterCount] = React.useState(0);
  const [bottomSheetActive, setBottomSheetActive] = React.useState(false);
  const [activeStatusFilter, setActiveStatusFilter] = React.useState(sortValue);
  const [filtersData, setFiltersData] = React.useState(filtersValue);
  const { control, handleSubmit, reset, formState: { errors } } = useForm({ defaultValues: filtersData });
  const [transaction, setTransaction] = React.useState([]);
  const [sellStatus, setSellStatus] = React.useState([]);
  const [landTypes, setLandTypes] = React.useState([]);
  const [transactionsMeta, setTransactionsMeta] = React.useState([]);
  const [landTypesMeta, setLandTypesMeta] = React.useState([]);
  const [landTypesWelfareAmenities, setLandTypesWelfareAmenities] = React.useState([]);
  const [landTypesBranches, setLandTypesBranches] = React.useState([]);

  React.useEffect(() => {
    let data = [];
    if(siteAddsTypes.transactions) {
      Object.values(siteAddsTypes.transactions).map((item) => {
        data.push({key: item._id, value: item.term_name, sell_status: item.sell_status, add_meta_list: item.add_meta_list});
      });
    }
    setTransaction(data);
  }, [myContext.addsTypes])

  React.useEffect(() => {
    setFilterCount(Object.keys(filtersValue).length);
    if(Object.keys(filtersValue).length > 0) {
      reset(filtersValue);
      if(filtersValue.transaction) {
        let targetTransaction = Object.values(transaction).filter(item => item.key === filtersValue.transaction);
        if(targetTransaction[0]) {
          getSellStatus(targetTransaction[0]);
          if(filtersValue.sell_status) {
            let targetSellStatus = Object.values(targetTransaction[0].sell_status).filter(item => item._id === filtersValue.sell_status);
            if(targetSellStatus[0]) {
              getLandType(targetSellStatus[0]);
              if(filtersValue.land_type) {
                let targetLandTypes = Object.values(targetSellStatus[0].land_types).filter(item => item._id === filtersValue.land_type);
                if(targetLandTypes[0]) {
                  getExtraMeta(targetLandTypes[0]);
                }
              }
            }
          }
        }
      }
    }
  }, [bottomSheetActive, transaction])

  const handlePresentModalPress = React.useCallback(() => {
    refRBSheet.current.open();
    setBottomSheetActive(true);
  }, []);

  const handleSort = (status) => {
    setActiveStatusFilter(status);
    sortData(status);
  }

  const getSellStatus = (data) => {
    let sellStatusData = [];
    if(data.sell_status) {
      Object.values(data.sell_status).map((item) => {
        sellStatusData.push({key: item._id, value: item.term_name, land_types: item.land_types});
      })
      setSellStatus(sellStatusData);
    }
    if(data.add_meta_list) {
      setTransactionsMeta(data.add_meta_list);
    }
  }

  const getLandType = (data) => {
    let landtypesData = [];
    if(data.land_types) {
      Object.values(data.land_types).map((item) => {
        landtypesData.push({key: item._id, value: item.term_name, add_meta_list: item.add_meta_list, welfare_amenities: item.welfare_amenities, branches: item.branches});
      })
    }
    setLandTypes(landtypesData);
  }

  const getExtraMeta = (data) => {
    if(data.add_meta_list) {
      setLandTypesMeta(data.add_meta_list);
    } 
    if(data.welfare_amenities) {
      setLandTypesWelfareAmenities(data.welfare_amenities);
    }
    if(data.branches) {
      setLandTypesBranches(data.branches);
    }
  }

  const renderFormItems = (data) => {
    switch (data.type) {
      case 'number':
        return (
          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TwinNumberTextInput
                label={data.label}
                placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                mode="outlined"
                activeOutlineColor="#c6c5c4"
                style={{ marginBottom: 24, fontSize: 14 }}
                error={errors[data.id]}
                onBlur={onBlur}
                myOnChangeText={onChange}
                value={value}
                keyboardType='number-pad'
              />
            )}
            name={data.id}
            defaultValue={data.value}
          />
        );
      break;
      case 'text':
          return (
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label={data.label}
                  placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors[data.id]}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                />
              )}
              name={data.id}
              defaultValue={data.value}
            />
          );
      break;
      case 'select':
        let options = [];
        if(Object.keys(data.choices).length > 0) {
          Object.values(data.choices).map((item, i) => {
            options.push({key: item.id, value: item.label});
          })
        }
        return (
          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Select
                label={data.label}
                placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                options={options}
                selectedValue={value}
                onBlur={onBlur}
                error={errors[data.id]}
                onValueChange={onChange}
                onSelect={(data) => {}}
                multiple
              />
            )}
            name={data.id}
            defaultValue={data.value}
          />
        );
      break;
      case 'on-off':
        return (
          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Checkbox onChange={onChange} onBlur={onBlur} value={value} label={data.label} />
            )}
            name={data.id}
            defaultValue={data.value}
          />
        );
      break;
    }
  }
  
  const memoizedData = React.useCallback((data) => renderFormItems(data), []);

  const submitFilter = (data) => {
    Object.keys(data).forEach(key => data[key] === undefined ? delete data[key] : {});
    submitFilterData(data);
    setFiltersData(data);
    refRBSheet.current.close();
    setBottomSheetActive(false);
    setFilterCount(Object.keys(data).length);
  }

  return (
    <View style={{ marginBottom: 18 }}>
      <View style={{ backgroundColor: '#e6eaee', borderWidth: 1, borderColor: '#999897', borderRadius: 6, padding: 12 }}>
        <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
          <TouchableRipple onPress={() => handleSort('all')} style={{ paddingHorizontal: 20, borderRadius: 4, paddingVertical: 14, flexDirection: 'row', alignItems: 'center', backgroundColor: activeStatusFilter === 'all' ? '#292D32' : 'transparent' }}>
            <>
              <Text style={{ fontSize: 12, color: activeStatusFilter === 'all' ? '#fff' : '#495157' }}>همه</Text>
              <View dir="rtl" style={{ width: 25, height: 25, marginStart: 8, justifyContent: 'center', alignItems: 'center', backgroundColor: activeStatusFilter === 'all' ? '#FF0000' : '#495157', borderRadius: 4 }}><Text style={{ color: '#fff', fontSize: 11 }}>{adsDetail.all}</Text></View>
            </>
          </TouchableRipple>
          <TouchableRipple onPress={() => handleSort(1)} style={{ paddingHorizontal: 20, borderRadius: 4, paddingVertical: 14, flexDirection: 'row', alignItems: 'center', backgroundColor: activeStatusFilter === 1 ? '#292D32' : 'transparent' }}>
            <>
              <Text style={{ fontSize: 12, color: activeStatusFilter === 1 ? '#fff' : '#495157' }}>تایید شده</Text>
              <View dir="rtl" style={{ width: 25, height: 25, marginStart: 8, justifyContent: 'center', alignItems: 'center', backgroundColor: activeStatusFilter === 1 ? '#3C9A4F' : '#495157', borderRadius: 4 }}><Text style={{ color: '#fff', fontSize: 11 }}>{adsDetail.confirm_add}</Text></View>
            </>
          </TouchableRipple>
          <TouchableRipple onPress={() => handleSort(0)} style={{ paddingHorizontal: 20, borderRadius: 4, paddingVertical: 14, flexDirection: 'row', alignItems: 'center', backgroundColor: activeStatusFilter === 0 ? '#292D32' : 'transparent' }}>
            <>
              <Text style={{ fontSize: 12, color: activeStatusFilter === 0 ? '#fff' : '#495157' }}>در انتظار بررسی</Text>
              <View dir="rtl" style={{ width: 25, height: 25, marginStart: 8, justifyContent: 'center', alignItems: 'center', backgroundColor: activeStatusFilter === 0 ? '#FFA200' : '#495157', borderRadius: 4 }}><Text style={{ color: '#fff', fontSize: 11 }}>{adsDetail.waiting_confirm}</Text></View>
            </>
          </TouchableRipple>
          <TouchableRipple onPress={() => handleSort(2)} style={{ paddingHorizontal: 20, borderRadius: 4, paddingVertical: 14, flexDirection: 'row', alignItems: 'center', backgroundColor: activeStatusFilter === 2 ? '#292D32' : 'transparent' }}>
            <>
              <Text style={{ fontSize: 12, color: activeStatusFilter === 2 ? '#fff' : '#495157' }}>رد شده</Text>
              <View dir="rtl" style={{ width: 25, height: 25, marginStart: 8, justifyContent: 'center', alignItems: 'center', backgroundColor: activeStatusFilter === 2 ? '#D61600' : '#495157', borderRadius: 4 }}><Text style={{ color: '#fff', fontSize: 11 }}>{adsDetail.reject_add}</Text></View>
            </>
          </TouchableRipple>
        </ScrollView>
      </View>
      {
        !hideFilter &&
          <ScrollView contentContainerStyle={{ paddingTop: 12 }} horizontal={true} showsHorizontalScrollIndicator={false}>
            <TouchableOpacity onPress={handlePresentModalPress} style={{ flexDirection: 'row', alignItems: 'center', marginEnd: 8 }}>
              <Sort size="24" color="#292D32" variant="Outline"/>
              <Text dir="rtl" style={{ fontSize: 12, color: '#292D32', fontFamily: 'IRANSans_Bold', marginStart: 8, direction: 'rtl' }}>{filterCount} فیلتر</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handlePresentModalPress} style={{ paddingHorizontal: 12, paddingVertical: 6, borderWidth: 1, borderColor: '#BFC0C5', borderRadius: 6, marginEnd: 8 }}>
              <Text style={{ fontSize: 12, color: '#BFC0C5' }}>نوع معامله</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handlePresentModalPress} style={{ paddingHorizontal: 12, paddingVertical: 6, borderWidth: 1, borderColor: '#BFC0C5', borderRadius: 6, marginEnd: 8 }}>
              <Text style={{ fontSize: 12, color: '#BFC0C5' }}>نوع کاربری</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handlePresentModalPress} style={{ paddingHorizontal: 12, paddingVertical: 6, borderWidth: 1, borderColor: '#BFC0C5', borderRadius: 6, marginEnd: 8 }}>
              <Text style={{ fontSize: 12, color: '#BFC0C5' }}>نوع ملک</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handlePresentModalPress} style={{ paddingHorizontal: 12, paddingVertical: 6, borderWidth: 1, borderColor: '#BFC0C5', borderRadius: 6, marginEnd: 8 }}>
              <Text style={{ fontSize: 12, color: '#BFC0C5' }}>قیمت کل</Text>
            </TouchableOpacity>
            <TouchableOpacity onPress={handlePresentModalPress} style={{ paddingHorizontal: 12, paddingVertical: 6, borderWidth: 1, borderColor: '#BFC0C5', borderRadius: 6, marginEnd: 8 }}>
              <Text style={{ fontSize: 12, color: '#BFC0C5' }}>متراژ</Text>
            </TouchableOpacity>
          </ScrollView>
      }
      <RBSheet
        ref={refRBSheet}
        closeOnDragDown={true}
        closeOnPressMask={true}
        height={height - 100}
        openDuration={height - 200}
        customStyles={{
          wrapper: {
            backgroundColor: "rgba(0, 0, 0, 0.3)"
          },
          draggableIcon: {
            backgroundColor: "#555"
          }
        }}
      >
        <ScrollView contentContainerStyle={{ paddingHorizontal: 18 }}>
          <View style={{ flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
            <View style={{ flexDirection: Platform.OS === 'web' ? 'row-reverse' : 'row', alignItems: 'center' }}>
              <TouchableRipple dir="rtl" onPress={() => refRBSheet.current.close()} borderless style={{ width: 40, height: 40, alignItems: 'center', justifyContent: 'center', borderRadius: 38, marginEnd: 8 }}><ArrowRight2 size="24" color="#292d32" variant="Outline"/></TouchableRipple>
              <Text style={{ fontSize: 14, color: '#292D32', fontFamily: 'IRANSans_Medium', textAlign: 'center' }}>فیلتر آگهی‌ها</Text>
            </View>
            <TouchableOpacity onPress={() => submitFilter({})}><Text style={{ fontSize: 11, color: '#D61600' }}>حذف همه</Text></TouchableOpacity>
          </View>
          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <TextInput
                dir="rtl"
                label="کد آگهی"
                placeholder="کد آگهی مورد نظر را وارد کنید"
                mode="outlined"
                activeOutlineColor="#c6c5c4"
                textAlign="right"
                style={{ marginBottom: isMy ? 10 : 22, fontSize: 14, direction: 'rtl', textAlign: 'right' }}
                contentStyle={{ direction: 'rtl', textAlign: 'right' }}
                error={errors.phone}
                onBlur={onBlur}
                onChangeText={onChange}
                maxLength={4}
                defaultValue={value}
                keyboardType='number-pad'
              />
            )}
            name="postId"
          />
          {
            isMy &&
              <>
                <Controller
                  control={control}
                  rules={{
                    required: false,
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <TextInput
                      label={isCus ? "شماره مشتری" : "شماره مالک"}
                      placeholder={isCus ? "شماره مشتری خود را وارد کنید" : "شماره مالک آگهی خود را وارد کنید"}
                      mode="outlined"
                      activeOutlineColor="#c6c5c4"
                      style={{ marginBottom: 10, fontSize: 14 }}
                      error={errors.phone}
                      onBlur={onBlur}
                      onChangeText={onChange}
                      defaultValue={value}
                      keyboardType='number-pad'
                    />
                  )}
                  name="phone"
                />
                <Controller
                  control={control}
                  rules={{
                    required: false,
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <TextInput
                    label={isCus ? "نام مشتری" : "نام مالک"}
                    placeholder={isCus ? "نام مشتری خود را وارد کنید" : "نام مالک آگهی خود را وارد کنید"}
                      mode="outlined"
                      activeOutlineColor="#c6c5c4"
                      style={{ marginBottom: 22, fontSize: 14 }}
                      error={errors.malekName}
                      onBlur={onBlur}
                      onChangeText={onChange}
                      defaultValue={value}
                    />
                  )}
                  name="malekName"
                />
              </>
          }
          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Select
                label="منطقه"
                placeholder="جستجو منطقه مورد نظر"
                options={myContext.locationData}
                selectedValue={value}
                onBlur={onBlur}
                error={errors.region}
                onValueChange={onChange}
                onSelect={(data) => {}}
                multiple
              />
            )}
            name="region"
          />
          <Controller
            control={control}
            rules={{
              required: false,
            }}
            render={({ field: { onChange, onBlur, value } }) => (
              <Select
                label="نوع معامله"
                placeholder="جستجو نوع معامله مورد نظر"
                options={transaction}
                selectedValue={value}
                onBlur={onBlur}
                error={errors.transaction}
                onValueChange={onChange}
                onSelect={(data) => getSellStatus(data)}
              />
            )}
            name="transaction"
          />
          {
            Object.keys(sellStatus).length > 0 &&
              <Controller
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Select
                    label="کاربری ملک"
                    placeholder="جستجو کاربری ملک مورد نظر"
                    options={sellStatus}
                    selectedValue={value}
                    onBlur={onBlur}
                    error={errors.sell_status}
                    onValueChange={onChange}
                    onSelect={(data) => getLandType(data)}
                  />
                )}
                name="sell_status"
              />
          }
          {
            Object.keys(landTypes).length > 0 &&
              <Controller
                control={control}
                rules={{
                  required: false,
                }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Select
                    label="نوع ملک"
                    placeholder="جستجو نوع ملک مورد نظر"
                    options={landTypes}
                    selectedValue={value}
                    onBlur={onBlur}
                    error={errors.land_type}
                    onValueChange={onChange}
                    onSelect={(data) => getExtraMeta(data)}
                  />
                )}
                name="land_type"
              />
          }
          {
            Object.keys(transactionsMeta).length > 0 && 
              <View>
                <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>امکانات ملک</Text>
                {Object.values(transactionsMeta).map(item => memoizedData(item))}
                {Object.keys(landTypesMeta).length > 0 && Object.values(landTypesMeta).map(item => memoizedData(item))}
              </View>
          }
          {
            Object.keys(landTypesWelfareAmenities).length > 0 && 
              <View>
                <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>امکانات رفاهی</Text>
                {Object.values(landTypesWelfareAmenities).map(item => memoizedData(item))}
              </View>
          }
          {
            Object.keys(landTypesBranches).length > 0 &&
              <View style={{ marginTop: 16 }}>
                <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>انشعابات</Text>
                {Object.values(landTypesBranches).map(item => memoizedData(item))}
              </View>
          }
        </ScrollView>
        <View style={{ paddingHorizontal: 18, paddingVertical: 10 }}><Button labelStyle={{ fontSize: 16 }} style={{ marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={handleSubmit(submitFilter)}>اعمال فیلتر</Button></View>
      </RBSheet>
    </View>
  );
};